/* Semáforo del SLA de las acciones correctivas (SST): verde en día, amarillo
 * si vence hoy o mañana, rojo si venció. El color y el texto los calcula EMSYS. */
import { COLORES_SEMAFORO, Semaforo } from "src/services/sst";

export const SemaforoChip: React.FC<{ semaforo: Semaforo }> = ({ semaforo }) => {
  const c = COLORES_SEMAFORO[semaforo.color] || COLORES_SEMAFORO.gris;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        whiteSpace: "nowrap",
        fontSize: 12,
        fontWeight: 600,
        padding: "2px 8px",
        borderRadius: 10,
        color: c.texto,
        background: c.fondo,
      }}
    >
      <span style={{ width: 9, height: 9, borderRadius: "50%", background: c.texto }} />
      {semaforo.texto}
    </span>
  );
};

export default SemaforoChip;
